// extracted by mini-css-extract-plugin
module.exports = {"parallax":"Card-module--parallax--1BsAb","parallaxImageWrapper":"Card-module--parallaxImageWrapper--1Rm5M"};